export default __webpack_public_path__ + "static/our-story-3b91cede74ec67367cde0b286138e52a.svg";